import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import CommentsActions from 'app/actions/CommentsActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCommentsTransactions } from 'app/selectors/ugc/CommentsSelector';
import { selectCommentEntities } from 'app/selectors/EntitiesSelector';
import { selectOpenUgcEditors } from 'app/selectors/ui/UgcEditorSelector';
import { CommentEditor } from '.';

export class CommentEditorContainer extends React.PureComponent {
  render() {
    return <CommentEditor {...this.props} />;
  }
}

CommentEditorContainer.propTypes = {
  // ownProps
  catalogBib: catalogBibShape,
  commentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleCancel: PropTypes.func,
  handleSuccess: PropTypes.func,

  // Props from Redux store
  open: PropTypes.bool,
  currentUser: userIdentityShape,
  initialContent: PropTypes.string,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { commentId } = ownProps;
  return {
    currentUser: selectCurrentUser(state),
    commentsTransactions: selectCommentsTransactions(state),
    initialContent: commentId ? selectCommentEntities(state).getIn([commentId.toString(), 'comment']) : '',
    open: !!commentId || selectOpenUgcEditors(state).has('comment')
  };
};

const mapDispatchToProps = dispatch => ({
  commentsActions: bindActionCreators(CommentsActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentEditorContainer);
